import React from "react";
import { useTranslation } from "react-i18next";
import { Props } from "./types";
import styles from "./styles.scss";

function Header(_: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.header}>
      <div className={styles.headerItem}>
        <p className={styles.title}>
          {t("projectPage.documentsPage.reportsPage.header.name")}
        </p>
      </div>
      <div className={styles.headerItem}>
        <p className={styles.title}>
          {t("projectPage.documentsPage.reportsPage.header.submissionDate")}
        </p>
      </div>
      <div className={styles.headerItem}>
        <p className={styles.title}>
          {t("projectPage.documentsPage.reportsPage.header.author")}
        </p>
      </div>
      <div className={styles.headerItem}>
        <p className={styles.title}>
          {t("projectPage.documentsPage.reportsPage.header.indicators")}
        </p>
      </div>
    </div>
  );
}

export { Header };
